var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "onboarding-screen-panel" }, [
    _c("div", { staticClass: "onboarding-screen-panel__overlay" }),
    _vm._v(" "),
    _c("div", { staticClass: "onboarding-screen-panel__container" }, [
      _c(
        "section",
        { staticClass: "onboarding-screen-panel__header" },
        [
          _c(
            "h1",
            {
              staticClass:
                "onboarding-screen-panel__header-title typographies-display-brand-large"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Votre essai gratuit Sellsy")) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _vm.isVariationDemoButtonAtTop
            ? _c("CompassButton", {
                staticClass: "onboarding-screen-panel__header-button",
                attrs: {
                  "data-bot": "ask-for-demo-top-right",
                  label: _vm.$t.__("common.actions.ask_demo")
                },
                on: {
                  click: function($event) {
                    return _vm.redirectTo(
                      "https://go.sellsy.com/demande-de-rendez-vous",
                      "_blank"
                    )
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("CompassIconButton", {
            attrs: { icon: "close" },
            on: { click: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "onboarding-screen-panel__content" },
        [
          _c("OnboardingScreen", {
            attrs: { columns: _vm.columns, isLoading: _vm.isLoading }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }